export default __webpack_public_path__ + "static/media/controle-ponto-gertec.7333cff1.png";